<template>
    <div class="main-wrapper">
        <header class="section-header">     
            <div class="header_logo">
                <!-- <img src="@/assets/images/company/Boolland_logo_white_full.png" alt=""> -->
            </div>
            <nav class="font-monospace">
                <!-- <router-link :to="{ name: 'Home' }">//Home</router-link> -->
            </nav>        
            <div class="header_sub_nav text-end">
                <router-link v-if="route.path !== '/book'" to="/book" class="contact-btn">Contact Us</router-link>
            </div>
        </header>        
        <div class="main_page">
            <router-view />
        </div>
    </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
const route = useRoute();
</script>

<style lang="scss">    
    // @import '../assets/styles/boolland.scss';
    
    :root {
      --gutter: 2rem;
      --body-color: #e5e5e5;
    }

    @media (max-width: 768px) {
      :root {
        --gutter: 1rem;
      }
    }

    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    body {
      background: #050505;
      font-family: "Plus Jakarta Sans", sans-serif;
      overflow-x: hidden;
    }

    .mega_text {
      font-size: clamp(4rem, 15vw, 12rem);
      font-weight: 800;
      letter-spacing: -0.05em;
      text-transform: lowercase;
    }

    .main-wrapper{
        position: relative;    
        background: #050505;
        color: var(--body-color);
        min-height: 100vh;
    }
    
    .section-header{
        position: absolute;
        top: 0%;
        left: 0%;
        width: 100%;
        z-index: 100;
        display: flex;
        padding: var(--gutter);
        align-items: center;
        mix-blend-difference: difference;

        .header_logo{
            flex: 1 0 0%;
            .logo_text {
              font-weight: 800;
              text-decoration: none;
              color: #ffffff;
              font-size: 1.2rem;
              letter-spacing: -0.02em;
            }
            img{    
                height: 1.5rem;
            }
        }                    

        nav{
            flex: 1 0 0%;
            display: flex;
            gap: 15px;
            font-size: 0.8rem;
            justify-content: center;
            align-items: center;
            a{
                color: #ffffff !important;    
                text-decoration: none;            
            }
        }
        .header_sub_nav{
            flex: 1 0 0%;
            .contact-btn {
              display: inline-block;
              text-decoration: none;
              background: transparent;
              border: 1px solid #ffffff;
              color: #ffffff;
              padding: 0.5rem 1.5rem;
              border-radius: 999px;
              font-size: 0.7rem;
              text-transform: uppercase;
              letter-spacing: 0.1em;
              cursor: pointer;
              transition: all 0.3s ease;
              white-space: nowrap;
              &:hover {
                background: #ffffff;
                color: #000000;
              }
            }
        }
    }
</style>
